import { useSyncExternalStore } from "react";
import type { ReadableStore } from "@wayfind/core";

/** Subscribes a component to a core store. One line, no state library. */
export function useStore<T>(store: ReadableStore<T> | null): T | null {
  return useSyncExternalStore(
    listener => (store ? store.subscribe(listener) : () => {}),
    () => (store ? store.get() : null),
    () => (store ? store.get() : null)
  );
}
